import "./CoreValueItem.css";
import "./CoreValueItemResponsive.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CustomAnchor from "../../shared/Anchor/CustomAnchor";
import { faExternalLinkSquare } from "@fortawesome/free-solid-svg-icons";

type CoreValueItemProps = {
  item: {
    icon: string;
    name: string;
    classn: string;
    description: string;
    cta: string;
    iconType: string;
  };
};

function CoreValueItem({
  item: { icon, name, classn, description, cta, iconType },
}: CoreValueItemProps) {
  return (
    <div
      className={`p-2 d-flex justify-content-center align-items-center ${classn}`}
    >
      <div className={`core-value-item`}>
        <div className="icon-container">
          <span>
            {iconType === "image" ? (
              <img
                src={require(`../../assets/images/core-values/${icon}`)}
                alt="core value icon"
                onContextMenu={(e) => e.preventDefault()}
              />
            ) : (
              icon
            )}
          </span>
          <CustomAnchor path={cta} classname="core-value-external-link">
            <FontAwesomeIcon icon={faExternalLinkSquare} />
          </CustomAnchor>
        </div>
        <div className="core-value-name">
          <h3>{name}</h3>
          <p>{description}</p>
        </div>
      </div>
    </div>
  );
}

export default CoreValueItem;
